export default "__VITE_ASSET__CB8iSil5__"